import { getInvestmentDetailsRoute } from "@verivest/shared-components";
import React from "react";
import { useHistory } from "react-router-dom";
import { Button } from "../..";
import { ActiveInvestmentCardProps } from "./horizontal-cards.types";
import { InvestmentCard } from "./InvestmentCard";

export const ActiveInvestmentCard: React.FC<ActiveInvestmentCardProps> = ({
  children,
  header,
  manager,
  imageUrl,
  accountId,
  offeringId,
  ...rest
}) => {
  const history = useHistory();

  const navigateToInvestmentWizard = () => {
    const url = getInvestmentDetailsRoute(
      accountId as string,
      offeringId as string,
    );
    history.push(url);
  };

  return (
    <InvestmentCard
      manager={manager}
      imageUrl={imageUrl}
      header={header}
      actions={
        <>
          <Button onClick={navigateToInvestmentWizard}>View investment</Button>
        </>
      }
      {...rest}
    >
      {children}
    </InvestmentCard>
  );
};
